import React, { useEffect, useState } from "react";
import "../../Components/Header/Header.scss";
import './ParticipantDashboard.scss';
import LFTLogo from "../../Assets/Images/LFT_logo.png";
import { useParams } from "react-router-dom";
import { participantServices } from "../../Services/API/participantsServices";
import { dateUtils } from "../../Utils/DateFormatter";
import Loader from "../../Components/Loader/Loader";
import { RWebShare } from "react-web-share";
import shareIcon from "../../Assets/Images/share-icon.svg"
import { formatAmount } from "../../Utils/constants";

export default function ParticipantDashboard() {
  const { id } = useParams();
  const [loader, setLoader] = useState(true);
  const [fundraisersList, setFundraisersList] = useState([]);

  const getParticipantDashboardDetails = () => {
    participantServices.getParticipantDashboard(id)
      .then((res) => {
        setFundraisersList(res?.data);
        setLoader(false)
      }).catch((error) => {
        console.log(error)
      }
      )
  }
  useEffect(() => {
    getParticipantDashboardDetails();
  }, [id])

  if (loader) {
    return (
      <Loader />
    )
  } else {
    return (
      <>
        <div className="header">
          <div className="logo">
            <img
              className="logo-img"
              src={LFTLogo}
              alt="LFT logo"
            />
          </div>
        </div>
        <div className="Dashboard-container participant-dash">
          <div className="participant-dashboard-header">My Fundraisers</div>
          {fundraisersList?.map((item) => {
            return (
              <div className="participant-fundraiser-item">
                <div className="name-date-info">
                  <div className="name">{item?.campaignTitle}</div>
                  <div className="date">{`${dateUtils?.dateToPhrase(item?.startDate)} to ${dateUtils?.dateToPhrase(item?.endDate)}`}</div>
                </div>
                <div className="location">{item?.location}</div>
                <div className="contribution">
                  <span className="label">My contribution</span>
                  <span className="amounts">{`${formatAmount(item?.totalContribution)} / $${item?.goal}`}</span>
                </div>
                <div className="sharelink">
                  <RWebShare
                    data={{
                      url: item?.shareUrl,
                    }}
                  >
                    <img className="share-icon" src={shareIcon} alt="share unique campaign link" />
                  </RWebShare>
                </div>
              </div>
            )
          })}
        </div>
      </>
    )
  }
}
